/**
 * Whether the reader may read a document's content, as the API decided it for them (#6992).
 *
 * The API sends it by number: `DocumentContentAccess` has no string-enum converter, and an API
 * response is written by Newtonsoft. `Allowed` is 0, so never test it with `if (access)`.
 *
 * `Restricted` is left out of what a page says before a download. Only a read endpoint decides the
 * value for the reader; an upload's answer sends `Restricted` as a default, not as a verdict, so a
 * page that disabled Download on it would refuse a person their own upload.
 */
export enum DocumentContentAccess {
  /** The reader may read the content. */
  Allowed = 0,
  /** The reader holds no access to the document. */
  Restricted = 1,
  /** Still being processed, or processing failed; the content is withheld from every reader. */
  Quarantined = 2,
  /** The reader may open the document, and lacks access to one of its subject matters. */
  SubjectMatterRestricted = 3,
}
